import { render } from "./customMade.vue?vue&type=template&id=d0376fd6&scoped=true&bindings={\"navId\":\"data\",\"topImg\":\"data\",\"playImg\":\"data\",\"midMainBox\":\"data\",\"imgList\":\"data\",\"midmain2bottom\":\"data\"}"
import script from "./customMade.vue?vue&type=script&lang=js"
export * from "./customMade.vue?vue&type=script&lang=js"

import "./customMade.vue?vue&type=style&index=0&id=d0376fd6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d0376fd6"

export default script